import { useCompanySlug } from '#/store/ducks/company'
import { useFarmSlug } from '#/store/ducks/farm'
import { isBusinessEnvironment } from '#/utils'

export default function useAppContext() {
  const farmSlug = useFarmSlug()
  const companySlug = useCompanySlug()

  if (farmSlug && !isBusinessEnvironment()) {
    return 'farm'
  }
  if (companySlug) {
    return 'company'
  }
  return 'system'
}
